import { space, SpaceBetween } from '@sunwebgroup/ui-components';
import {
  FilterDescription,
  FilterLabel,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/Filters/Filters';
import * as React from 'react';
import { useIntl } from '@/intl';

export function ChildSeatsFilter () {
  const intl = useIntl();

  return (
    <SpaceBetween direction='y' spacing={space('primitives_space_8')}>
      <FilterLabel>{intl.formatMessage({id: `checkout_steps_ancillaries_car_rental_filtering_filters_child_seats_label`})}</FilterLabel>
      <FilterDescription>{intl.formatMessage({id: `checkout_steps_ancillaries_car_rental_filtering_filters_child_seats_type_supporting_text`})}</FilterDescription>
    </SpaceBetween>
  )
}
